import { createAction, createAsyncAction } from "typesafe-actions";
import filtersConstants from "store/features/filters/filters.constants";
import { FilterFields } from "api";

const {
    FETCH_CREATIVE_MAPPINGS_FILTERS_REQUEST,
    FETCH_CREATIVE_MAPPINGS_FILTERS_SUCCESS,
    FETCH_CREATIVE_MAPPINGS_FILTERS_FAILED,
    CLEAR_FILTER_FIELDS,
} = filtersConstants;

export const fetchCreativeMappingsFields = createAsyncAction(
    FETCH_CREATIVE_MAPPINGS_FILTERS_REQUEST,
    FETCH_CREATIVE_MAPPINGS_FILTERS_SUCCESS,
    FETCH_CREATIVE_MAPPINGS_FILTERS_FAILED
)<void, { fields: FilterFields[] }, ErrorHandler>();

export const clearFilterFields = createAction(CLEAR_FILTER_FIELDS)();
